/**
 * ManageCorrespondentsDialog - Dialog para gerenciar correspondentes
 */
import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Badge } from "../../ui/badge";
import { Plus, X } from "lucide-react";

export function ManageCorrespondentsDialog({
  open,
  onOpenChange,
  correspondentes,
  onAdicionarCorrespondente,
  onRemoverCorrespondente
}) {
  const [novoCorrespondente, setNovoCorrespondente] = useState("");

  const handleAdicionar = async () => {
    const sucesso = await onAdicionarCorrespondente(novoCorrespondente);
    if (sucesso) {
      setNovoCorrespondente("");
    }
  };

  const handleRemover = async (corresp) => {
    if (window.confirm(`Excluir o correspondente "${corresp}"?`)) {
      await onRemoverCorrespondente(corresp);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Gerenciar Correspondentes</DialogTitle>
          <DialogDescription>
            Adicione ou remova correspondentes
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Novo Correspondente</Label>
            <div className="flex gap-2">
              <Input
                placeholder="Ex: CONSIGPREV"
                value={novoCorrespondente}
                onChange={(e) => setNovoCorrespondente(e.target.value)}
                className="flex-1"
                data-testid="input-novo-correspondente"
              />
              <Button 
                onClick={handleAdicionar} 
                className="bg-purple-600 hover:bg-purple-700"
                data-testid="btn-adicionar-correspondente"
              >
                <Plus className="h-4 w-4" />
              </Button>
            </div>
          </div>
          
          <div className="space-y-2">
            <Label className="text-sm text-slate-500">Correspondentes existentes (clique no X para excluir):</Label>
            <div className="flex flex-wrap gap-2 p-3 bg-slate-50 rounded-lg max-h-[200px] overflow-y-auto">
              {correspondentes.map((corresp, idx) => (
                <Badge 
                  key={`corresp-${idx}`}
                  variant="outline" 
                  className="text-sm py-1 px-2 flex items-center gap-1 bg-white"
                >
                  {corresp}
                  <button
                    onClick={() => handleRemover(corresp)}
                    className="ml-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-full p-0.5"
                    data-testid={`btn-remover-correspondente-${corresp}`}
                  >
                    <X className="h-3 w-3" />
                  </button>
                </Badge>
              ))}
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
